/* eslint-disable no-prototype-builtins */
import MaskUtil from "core-ui/client/src/app/MaskUtil";
import DateUtil from "core-ui/client/src/app/DateUtil.js";
import beneficiaryTypeCodes from "../../../../common/constants/beneficiaryTypeCodes";
import beneficiaryDesignationCodes from "../../../../common/constants/beneficiaryDesignationCodes";

/**
 * Controller for the Beneficiaries Confirmation page.
 *
 * @param $scope
 * @param Beneficiary
 * @constructor
 */
function ConfirmationController(
    $scope,
    $translate,
    beneficiaryService,
    participantService,
    dataService,
    $state,
    eventBus,
    groupService
) {
    // ViewModel replaces $scope
    var vm = this;
    var serviceDateFormat = "MMDDYYYY";

    // var groupService = $injector.get('groupService');
    vm.isSubjectToFeva = false;

    $scope.data = {
        beneficiaries: {
            Primary: [],
            Contingent: []
        }
    };

    //
    // Translation Strings
    vm.translate = {
        confirmationNumber: {
            number: participantService.getConfirmationNumber()
        },
        maritalStatus: {
            value: participantService.getMaritalStatus()
        },
        socialSecurityNumber: {
            // These values will get populated below
            ssnAbbreviationBegin: "",
            ssnAbbreviationEnd: ""
        }
    };

    if (vm.translate.confirmationNumber.number === null) {
        $state.go("genericError");
    }

    // Translate the full text for "Social Security Number" to be used in the abbreviation title
    $translate("app.beneficiary.confirmationPage.socialSecurityNumber").then(
        function (translation) {
            vm.translate.socialSecurityNumber.ssnAbbreviationBegin =
                "<abbr title='" + translation + "'>";
            vm.translate.socialSecurityNumber.ssnAbbreviationEnd = "</abbr>";
        }
    );

    $scope.beneficiaryTypeCodes = beneficiaryTypeCodes;

    // Get the beneficiaries
    var beneficiaries = beneficiaryService.getRecords();
    //check to see if the beneficiary address required
    // eslint-disable-next-line no-unused-vars
    var beneficiaryAddressRequired;
    dataService.getBeneficiaryAddressRequired().then(function (beneficiaryAddressRequired) {
        angular.forEach(beneficiaries, function (beneficiary) {
            // Format the beneficiary name for display on the confirmation page
            beneficiary.name = beneficiaryService.getBeneficiaryName(beneficiary, true);

            var showDateOfTrust = vm.showDateOfTrust(beneficiary);
            var showDateOfBirth = vm.showDateOfBirth(beneficiary);
            var showTin = vm.taxIdentificationNumber(beneficiary);
            console.log(
                "beneficiary.dateOfBirth, format, maskUtil format:" +
                    beneficiary.dateOfBirth +
                    ", " +
                    serviceDateFormat +
                    ", " +
                    MaskUtil.MASKED_DATE_FORMAT
            );
            if (showDateOfTrust) {
                beneficiary.dateOfBirth = DateUtil.swapDateFormat(
                    beneficiary.dateOfBirth,
                    serviceDateFormat,
                    MaskUtil.MASKED_DATE_FORMAT
                );
            } else if (showDateOfBirth && !MaskUtil.isMasked(beneficiary.dateOfBirth)) {
                beneficiary.dateOfBirth = DateUtil.swapDateFormat(
                    beneficiary.dateOfBirth,
                    serviceDateFormat,
                    MaskUtil.MASKED_DATE_FORMAT
                );
            }
            console.log("beneficiary.dateOfBirth after formatting:" + beneficiary.dateOfBirth);

            if (showTin && !MaskUtil.isMasked(beneficiary.socialSecurityNumber)) {
                beneficiary.socialSecurityNumber = MaskUtil.maskTIN(
                    beneficiary.socialSecurityNumber
                );
            }

            if (beneficiaryAddressRequired === true) {
                if (
                    beneficiary.hasOwnProperty("address1") &&
                    beneficiary.hasOwnProperty("city") &&
                    beneficiary.hasOwnProperty("state") &&
                    beneficiary.hasOwnProperty("zipCode") &&
                    beneficiary.hasOwnProperty("country")
                ) {
                    //
                    // Format the beneficiary address for display on the confirmation page
                    beneficiary.address = beneficiary.address1;
                    if (beneficiary.address2) {
                        beneficiary.address += "<br/>" + beneficiary.address2;
                    }
                    if (beneficiary.country.code !== "US") {
                        beneficiary.address += "<br/>" + beneficiary.city;
                        beneficiary.address += ", " + beneficiary.country.description;
                    } else {
                        beneficiary.address += "<br/>" + beneficiary.city;
                        beneficiary.address += ", " + beneficiary.state.description;
                        beneficiary.address += ", " + beneficiary.country.description;
                    }
                    var zipCode = beneficiary.zipCode;

                    if (zipCode !== null) {
                        if (zipCode.length === 9) {
                            zipCode = zipCode.substr(0, 5) + "-" + zipCode.substr(5);
                        }

                        beneficiary.address += ", " + zipCode;
                    }
                }
            } else {
                beneficiary.address = null;
            }

            //
            // Group the beneficiaries by designation
            switch (beneficiary.beneficiaryDesignation) {
                case beneficiaryDesignationCodes.Primary:
                    $scope.data.beneficiaries.Primary.push(beneficiary);
                    break;

                case beneficiaryDesignationCodes.Contingent:
                    $scope.data.beneficiaries.Contingent.push(beneficiary);
                    break;
            }
        });
        console.log("beneficiaryAddressRequired: ", beneficiaryAddressRequired);
    });

    vm.navigateToList = function () {
        $state.go("accountDetails.beneficiaries.listBeneficiaries");
        /*beneficiaryService.reset();
        dataService.reset();
        participantService.reset();*/

        //$state.reload();
    };

    vm.hasPrimaryBeneficiaries = function () {
        return $scope.data.beneficiaries.Primary.length > 0;
    };

    vm.hasContingentBeneficiaries = function () {
        return $scope.data.beneficiaries.Contingent.length > 0;
    };

    vm.showRelationship = function (beneficiary) {
        return beneficiaryService.getType(beneficiary) == $scope.beneficiaryTypeCodes.Individual;
    };

    vm.showRelationshipNonInd = function (beneficiary) {
        return beneficiaryService.getType(beneficiary) !== $scope.beneficiaryTypeCodes.Individual;
    };

    vm.showSocialSecurityNumber = function (beneficiary) {
        return (
            beneficiary.socialSecurityNumber &&
            beneficiaryService.getType(beneficiary) == $scope.beneficiaryTypeCodes.Individual
        );
    };

    vm.taxIdentificationNumber = function (beneficiary) {
        return (
            beneficiary.socialSecurityNumber &&
            beneficiaryService.getType(beneficiary) !== $scope.beneficiaryTypeCodes.Individual
        );
    };

    vm.showDateOfBirth = function (beneficiary) {
        return (
            beneficiary.dateOfBirth &&
            beneficiaryService.getType(beneficiary) == $scope.beneficiaryTypeCodes.Individual
        );
    };

    vm.showDateOfTrust = function (beneficiary) {
        return (
            beneficiary.dateOfBirth &&
            beneficiaryService.getType(beneficiary) !== $scope.beneficiaryTypeCodes.Individual
        );
    };
    vm.showPhoneNumber = function (beneficiary) {
        return (
            beneficiary.phoneNumber &&
            beneficiaryService.getType(beneficiary) == $scope.beneficiaryTypeCodes.Individual
        );
    };

    vm.showAddress = function (beneficiary) {
        return beneficiary.address !== null;
    };

    if (vm.translate.confirmationNumber.number) {
        groupService.isSubjectToFEVA().then(function (response) {
            vm.isSubjectToFeva = response;
        });
    }
}

ConfirmationController.$inject = [
    "$scope",
    "$translate",
    "beneficiaryService",
    "participantService",
    "dataService",
    "$state",
    "eventBus",
    "groupService"
];

export default ConfirmationController;
